export default "https://cdn.msgboxx.io/static/media/WhatsAppLogo.1989d655.png";